'use client';

import { FC, useEffect } from 'react';
import Cookies from 'universal-cookie';

import { COOKIE_MICROCOPY_DEBUG } from 'src/constants/cookie.constants';
import { getUserGroupId } from 'src/general/components/Analytics/Analytics.helpers';
import { carmaAsciiInConsole } from 'src/general/helpers/carmaAscii';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

const cookies = new Cookies();

export const WebsiteGlobals: FC = () => {
  useEffect(() => {
    carmaAsciiInConsole();

    const userGroup = getUserGroupId();

    pushToDataLayer({
      event: 'app_init',
      userGroup,
    });

    // Add global method(s)
    if (globalThis.window !== undefined) {
      (window as any).carmaToggleMicrocopyDebug = () => {
        const expiryLength = 5 * 60 * 1000;
        if (cookies.get(COOKIE_MICROCOPY_DEBUG)) {
          // The remove method from cookie doesn't seem to work, using instead negactive expiry
          const expires = new Date(new Date().getTime() - expiryLength);
          cookies.set(COOKIE_MICROCOPY_DEBUG, false, {
            path: '/',
            secure: process.env.NODE_ENV === 'production',
            expires,
          });
        } else {
          // Cookie expiry 5min
          const expires = new Date(new Date().getTime() + expiryLength);
          cookies.set(COOKIE_MICROCOPY_DEBUG, true, {
            path: '/',
            secure: process.env.NODE_ENV === 'production',
            expires,
          });
        }

        window.location.reload();
      };
    }
  }, []);

  return null;
};
